<template>
    <div id="app" class="camera-container">
        <div v-show="isCameraOpen && isLoading" class="camera-loading d-flex justify-content-center align-items-center">
            <ul class="loader-circle list-unstyled d-flex align-items-center">
                <li class="spinner-grow text-primary mx-1" style="width: 1rem; height: 1rem;"></li>
                <li class="spinner-grow text-primary mx-1" style="width: 1rem; height: 1rem;"></li>
                <li class="spinner-grow text-primary mx-1" style="width: 1rem; height: 1rem;"></li>
            </ul>
        </div>
        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box  rounded  mx-auto position-relative" :class="{ 'flash': isShotPhoto }">
            <div class="camera-shutter position-absolute top-0 start-0 w-100 h-100 bg-white" :class="{ 'flash': isShotPhoto }"></div>
            <video v-show="!isPhotoTaken" ref="camera" width="260" height="340" autoplay class="rounded"></video>
            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" width="260" height="340" class="rounded"></canvas>
        </div>
        <div v-if="isCameraOpen && !isLoading && !isPhotoTaken" class="camera-shoot mt-2 d-flex justify-content-center align-items-center">
            <div class="btn btn-primary d-flex align-items-center" @click="takePhoto">
                <i class="ri-camera-fill mr-2" style="font-size: 1.5rem;"></i>
                <span class="fs-5">{{ $t('take_a_photo') }}</span>
            </div>
        </div>
        <div v-if="isPhotoTaken && isCameraOpen" class="camera-actions d-flex justify-content-center mt-2">
            <button type="button" class="btn btn-danger mr-2" @click="retake">Take a Photo Again</button>
            <button type="button" class="btn btn-success" @click="submit">{{$t('save')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CameraComponent',
    props: {
        openCamera: {
            type: Boolean,
            required: true
        },
        uploadHandler: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoading: false,
            stream: null
        };
    },
    watch: {
        openCamera(newVal) {
            if (newVal) {
                this.isCameraOpen = true;
                this.createCameraElement();
            } else {
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.isLoading = false;
                this.stopCameraStream();
                this.isCameraOpen = false;
            }
        }
    },
    methods: {
        createCameraElement() {
            this.isLoading = true;
            const constraints = {
                audio: false,
                video: { width: 260, height: 340 }
            };

            navigator.mediaDevices
                .getUserMedia(constraints)
                .then((stream) => {
                    this.isLoading = false;
                    this.stream = stream;
                    this.$refs.camera.srcObject = stream;
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.isCameraOpen = false;
                    this.$emit('update:openCamera', false);
                    this.$emit('camera-error', error);
                    alert("Camera access denied or not available. Please check your camera settings.");
                });
        },
        stopCameraStream() {
            if (this.stream) {
                this.stream.getTracks().forEach((track) => track.stop());
                this.stream = null;
            }
        },
        takePhoto() {
            if (!this.isPhotoTaken) {
                this.isShotPhoto = true;
                setTimeout(() => {
                    this.isShotPhoto = false;
                }, 50);
            }

            this.isPhotoTaken = true;
            const context = this.$refs.canvas.getContext('2d');
            context.drawImage(this.$refs.camera, 0, 0, 260, 340);
            this.stopCameraStream();
        },
        retake() {
            this.isPhotoTaken = false;
            this.createCameraElement();
            this.$emit('update:openCamera', true);
        },
        submit() {
            const dataURL = this.$refs.canvas.toDataURL('image/jpeg', 1);
            const file = this.dataURLtoFile(dataURL, `photo_${Date.now()}.jpeg`);
            this.uploadHandler(file);
            this.isPhotoTaken = false;
            this.$emit('update:openCamera', false);
        },
        dataURLtoFile(dataURL, filename) {
            const arr = dataURL.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        }
    },
    beforeDestroy() {
        this.stopCameraStream();
    }
};
</script>

<style scoped>
.camera-container {
    text-align: center;
    padding: 1rem;
}
.camera-box {
    max-width: 260px;
}
.camera-shutter {
    opacity: 0;
}
.camera-shutter.flash {
    opacity: 0.75;
    transition: opacity 0.05s ease-in-out;
}
.camera-box.flash {
    background-color: white;
}
.camera-loading {
    height: 5rem;
}
.loader-circle li {
    animation: bounce 1.4s infinite ease-in-out;
}
.loader-circle li:nth-child(2) {
    animation-delay: 0.2s;
}
.loader-circle li:nth-child(3) {
    animation-delay: 0.4s;
}
@keyframes bounce {
    0%, 100% {
        transform: translateY(-25%);
        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    }
    50% {
        transform: translateY(0);
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
}
</style>
